import { createContext } from "react";

import { DirectoryHealthCareProvider } from "./DirectoryHealthCareProvider";
import { PharmacyProxy } from "./PharmacyProxy";

export interface IPatientPreferredDirectoryContactsContext {
    patientContactId: string | null;
    preferredPharmacy: PharmacyProxy | null;
    externalConsultants: DirectoryHealthCareProvider[];
}

export const PatientPreferredDirectoryContactsContext = createContext<IPatientPreferredDirectoryContactsContext>({
    patientContactId: null,
    preferredPharmacy: null,
    externalConsultants: []
});
